import React from 'react'
import BookMarkSVG from '../icons/bookMarkSVG'
import ClockSVG from '../icons/clockSVG'
import SecuritySVG from '../icons/securitySVG'

const Features = () => {
  return (
    <section id="features">
      <div className="pt-16 pb-8 md:pt-12 layout-space lg:pt-20 xl:pt-32 xl:pb-32">
        <div className=" md:text-center md:mb-16">
          <h2 className="mb-3 heading">Mais do que um app de transcrição</h2>
          <p className="mb-8 sub-heading">
            Os recursos de produtividade o ajudarão a trabalhar com suas gravações e transcrições para você realizar mais do que nunca.
          </p>
        </div>
        <div className="max-w-6xl mx-auto md:flex lg:px-10">
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1 blue-dot-after">
            <div className="pt-6 pb-4">
              <ClockSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">TRANSCRIÇÃO VIA EMAIL</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              Em alguns Minutos
            </h4>
            <p className="pb-6 small">
              Seus áudios do gravador voz são transcritos e enviados automaticamente para seu email em um instante
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <SecuritySVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">SEMPRE SEGURO</h3>
            <h4 className="my-1 sub-heading text-accent bold">Sempre Sincronizado</h4>
            <p className="pb-6 small">
              Todas as reuniões, notas, áudios e transcrições com backup em sua nuvem (iCloud, Dropbox, Google Drive)
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <BookMarkSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">LÍDER DA INDÚSTRIA</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              Transcrição por I.A.
            </h4>
            <p className="pb-6 small">
              A transcrição manual leva horas. Aproveite mais suas interações e reuniões, permitindo que a VoxRec transcreva suas discussões.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Features
